import React, { useCallback } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router';
import { Container, Popover, Option, Text } from './styles/optionsMore';
import { IconPdf, IconCloud } from '~/presentation/base/icons';
import { makeRemoteGetByDownloadSupportDocs } from '~/main/factories/usecases/supportDoc/GetByDownloadSupportDocsFactory';
import { makeRemoteDeleteSupportDocs } from '~/main/factories/usecases/supportDoc/DeleteSupportDocsFactory';
import { makeReduxActiveMessage } from '~/main/factories/usecases/message/Update';
import { closeModal } from '~/utils/closeModal';
import { translator } from '../i18n';
import { iGuestData } from '~/domain/interfaces/models/GuestData';
import { makeRemoteDownloadByCodeSupportDocs } from '~/main/factories/usecases/supportDoc/DownloadByCodeSupportDocsFactory';

interface ownProps {
  supportDocID?: number;
  extension?: string;
}

const OptionsSupportDoc: React.FC<ownProps> = ({ supportDocID, extension }) => {
  const id = supportDocID || 1;
  const params = useLocation<{ guestData: iGuestData }>().state;

  async function downloadFile() {
    const code = params.guestData?.guest?.identification?.code;

    if (id === undefined) {
      alert('Selecione um arquivo');
      return;
    }

    if (Number.isNaN(id)) {
      alert('Selecione um arquivo');
      return;
    }

    if (code) {
      const { url } = await makeRemoteDownloadByCodeSupportDocs().get({
        code: String(code),
        docId: Number(id),
      });

      axios
        .get(url, {
          headers: { 'Content-Type': 'application/octet-stream' },
          responseType: 'blob',
        })
        .then(response => {
          const link = document.createElement('a');
          const urlToDownload = window.URL.createObjectURL(response.data);
          const name = 'FILE';
          link.href = urlToDownload;
          link.download = name;
          link.click();
        })
        .catch(err => {
          console.error('Falha ao realizar download do arquivo.', err);
        });
    } else {
      const { url } = await makeRemoteGetByDownloadSupportDocs().get({
        docId: id,
      });

      axios
        .get(url, {
          headers: { 'Content-Type': 'application/octet-stream' },
          responseType: 'blob',
        })
        .then(response => {
          const link = document.createElement('a');
          const urlToDownload = window.URL.createObjectURL(response.data);
          const name = 'FILE';
          link.href = urlToDownload;
          link.download = name;
          link.click();
        })
        .catch(err => {
          console.error('Falha ao realizar download do arquivo.', err);
        });
    }
  }

  const handleViewDetails = async () => {
    let downloadUrl = '';
    const code = params.guestData?.guest?.identification?.code;

    if (!code) {
      const { url } = await makeRemoteGetByDownloadSupportDocs().get({
        docId: Number(id),
      });
      downloadUrl = url;
    } else {
      const { url } = await makeRemoteDownloadByCodeSupportDocs().get({
        code: String(code),
        docId: Number(id),
      });
      downloadUrl = url;
    }

    window.open(downloadUrl, '_blank');
  };

  const pending = translator('Excluir documento');
  const confirmExclude = translator('Você deseja excluir o documento?');

  const handleDelete = useCallback(() => {
    makeReduxActiveMessage().active({
      active: 'delete',
      title: pending,
      content: confirmExclude,
      actionOk: () => {
        makeRemoteDeleteSupportDocs().delete({
          docId: id,
        });
        closeModal();
      },
      actionCancel: closeModal,
    });
  }, [confirmExclude, id, pending]);

  const shareFile = ({ message }: any) => {
    // return <SendMail message={message} />;
  };

  return (
    <Container>
      <Popover>
        {/* {extension === 'pdf' && (
          <Option
            onClick={() =>
              History.getHistory().push('/supportdoc/detail', {
                docId: id,
                from: window.location.pathname.replaceAll('/', ''),
              })
            }
          >
            <IconPdf />
            <Text>Visualizar PDF</Text>
          </Option>
        )} */}

        <Option onClick={handleViewDetails}>
          <IconPdf />
          <Text>Visualizar</Text>
        </Option>

        <Option id="btn_download" onClick={() => downloadFile()}>
          <IconCloud />
          <Text>Baixar</Text>
        </Option>
        {/* TODO: SUPPORTING CLINICAL RECORDS DELETE */}
        {/* <Option onClick={handleDelete}>
          <IconDelete />
          <Text>Deletar</Text>
        </Option> */}
        {/* <Option>
          <IconHome />
          <Text>Acesso para farmácia</Text>
        </Option> */}
        {/* <Option>
          <IconEmail />
          <Text>Reenviar por e-mail</Text>
        </Option> */}
      </Popover>
    </Container>
  );
};

export default OptionsSupportDoc;
